export default __webpack_public_path__ + "static/media/Location_Sachsen-Anhalt.a88034fe.svg";